import styled from 'styled-components';

export const InfoTitle = styled.span`
  display: block;
  text-transform: uppercase;
  font-size: 1.2rem;
  /* font-weight: 700; */
  color: #6D6D6D;
  margin-bottom: 5px;
`;

export const InfoValue = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  text-transform: uppercase;
  color: #454545;
  & svg {
    margin-right: 8px;
  }
`;